import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";

import InvestorDetailsProjects from "./InvestorDetailsProjects";
import InvestorDetailsCard from "./InvestorDetailsCard";

import {
  getCurrentInvestor,
  updateCurrentInvestor,
} from "../../../../actions/investorsActions";
import { resetInvestorsState } from "../../../../slices/investorsSlice";
import { getInvestmentsList } from "../../../../actions/investmentsActions";
import InvestortChangePasswordSection from "../../associates/ById/InvestorChangePassword/InvestortChangePasswordSection";

const styles = {
  columns: {
    px: "1rem",
  },
};

const InvestorDetails = () => {
  const params = useParams();

  const [investor, setInvestor] = useState({
    _id: "",
    name: "",
    email: "",
    phoneNumber: "",
    investor: "",
  });

  useEffect(() => {
    dispatch(getCurrentInvestor({ id: params.id }));
    dispatch(getInvestmentsList({ query: { associateRef: params.id } }));
    return () => dispatch(resetInvestorsState());
  }, []);

  const dispatch = useDispatch();
  const current = useSelector((state) => state.investors.current);

  useEffect(
    () =>
      setInvestor({
        ...investor,
        ...current,
        investmentDate: current.investmentDate?.slice(0, 10) ?? "",
      }),
    [current]
  );

  const handleChange = (e) => {
    setInvestor({ ...investor, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phoneNumber } = investor;

    dispatch(
      updateCurrentInvestor({
        id: params.id,
        investor: { name, email, phoneNumber, investor: investor.investor },
      })
    );
  };
  const investments = useSelector((state) => state.investments.list);
  const project = useSelector((state) => state.projects.current);
  console.log({
    project,
    invest: investments.filter((i) => i.projectRef._id === project._id),
  });

  return (
    <>
      <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: "1rem" }}>
        Inversionista {investor.name ?? params.id}
      </Typography>
      <Grid container>
        <Grid item xs={12} md={7} sx={styles.columns}>
          <InvestorDetailsCard
            {...investor}
            investments={current}
            onChange={handleChange}
            onSubmit={handleSubmit}
          />
        </Grid>
        <Grid item xs={12} md={5} sx={styles.columns}>
          <InvestorDetailsProjects />
        </Grid>
        <Grid item xs={12}>
          <InvestortChangePasswordSection />
        </Grid>
      </Grid>
    </>
  );
};

export default InvestorDetails;
